import pizza from '~/assets/images/pizza.png';
import money from '~/assets/images/money.png';
import briefcase from '~/assets/images/briefcase.png';
import bagOfMoney from '~/assets/images/bagOfMoney.png';
import bank from '~/assets/images/bank.png';
import thumb from '~/assets/images/thumb.png';
import noIdea from '~/assets/images/noIdea.png';
import handshake from '~/assets/images/handshake.png';
import notEmoji from '~/assets/images/notEmoji.png';
import sometimes from '~/assets/images/sometimes.png';
import emojiMoney from '~/assets/images/emojiMoney.png';
import chart from '~/assets/images/chart.png';
import idk from '~/assets/images/idk.png';
import easy from '~/assets/images/easy.png';
import average from '~/assets/images/average.png';
import serious from '~/assets/images/serious.png';
import strong from '~/assets/images/strong.png';

import chartDown from '~/assets/illustrations/ChartDown.svg';
import chartUp from '~/assets/illustrations/ChartUp.svg';

import { OptionsQuestionProps, QuestionProps } from '../dto/questionsDTO';

const adultQuestions: QuestionProps[] = [ {
  id: '1',
  title: 'Are you happy with your financial situation at the moment?',
  type: 'satisfaction',
}, {
  id: '2',
  title: 'Do you understand how the stock market works?',
  type: 'satisfaction',
}, {
  id: '3',
  title: 'What’s a stock?',
  subtitle: "It's okay if you make mistakes",
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: 'A stock is a tiny piece of a company. Buying a stock makes you a mini-owner of a company, like owning a slice of a pizza.',
    icon: pizza,
  },
  options: [ {
    id: '1',
    title: 'A tiny piece of a company',
    isCorrect: true,
  }, {
    id: '2',
    title: 'A loan to the government',
  }, {
    id: '3',
    title: 'A coupon to buy items',
  }, {
    id: '4',
    title: 'A savings account',
  } ],
}, {
  id: '4',
  title: 'What is compound interest?',
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: "Saving 100€ monthly in a bank gets you 36,000€ in 30 years. Good, right? But if you invest that 100€? It could grow to 233,000€. That's the power of compound interest!",
    icon: money,
  },
  options: [ {
    id: '1',
    title: 'A special bank interest',
  }, {
    id: '2',
    title: 'Money making more money',
    isCorrect: true,
  }, {
    id: '3',
    title: 'Financial hobby',
  }, {
    id: '4',
    title: 'A one-time investing fee',
  } ],
}, {
  id: '5',
  title: 'What are ETFs?',
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: 'If you invest in an ETF, you are investing in many different companies at once. It’s a simple way of spreading risk!!',
    icon: briefcase,
  },
  options: [ {
    id: '1',
    title: 'A type of currency',
  }, {
    id: '2',
    title: 'Exclusive clubs for investors',
  }, {
    id: '3',
    title: 'Baskets of stocks traded on the stock market',
    isCorrect: true,
  }, {
    id: '4',
    title: 'High-interest savings accounts',
  } ],
}, {
  id: '6',
  title: 'Which of these shows a ‘bull market’?',
  type: 'imageOptions',
  isKnowledge: true,
  options: [ {
    id: '1',
    title: chartDown,
  }, {
    id: '2',
    title: chartUp,
    isCorrect: true,
  } ],
}, {
  id: '7',
  title: 'Could your money management use some improvement?',
  type: 'satisfaction',
}, {
  id: '8',
  title: 'What is an emergency fund?',
  type: 'options',
  options: [ {
    id: '1',
    title: 'Money for everyday spending',
  }, {
    id: '2',
    title: 'Money set aside for unexpected expenses',
    isCorrect: true,
  }, {
    id: '3',
    title: 'A fund for vacation',
  }, {
    id: '4',
    title: 'Money used for a fund of your future children',
  } ],
}, {
  id: '9',
  title: 'What does inflation mean for your money?',
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: 'Inflation means prices rise, so your money buys less. Imagine what €10 buys today might cost €12 in a few years.',
    icon: bagOfMoney,
  },
  options: [ {
    id: '1',
    title: "It increases your money's buying power",
  }, {
    id: '2',
    title: 'Prices rise, so your money buys less over time',
    isCorrect: true,
  }, {
    id: '3',
    title: "Inflation doesn't affect money",
  }, {
    id: '4',
    title: 'It only affects people with a lot of money',
  } ],
}, {
  id: '10',
  title: 'Are you confident in your understanding of economics?',
  type: 'satisfaction',
}, {
  id: '11',
  title: 'What do central banks do to keep the economy stable?',
  type: 'options',
  didYouKnow: {
    description: 'Central banks adjust interest rates to keep prices stable and support economic growth, ensuring people keep spending and investing.',
    icon: bank,
  },
  options: [ {
    id: '1',
    title: 'Spend more government money',
  }, {
    id: '2',
    title: 'Cut taxes for big companies',
  }, {
    id: '3',
    title: 'Change how much it costs to borrow money',
    isCorrect: true,
  }, {
    id: '4',
    title: 'Directly make sure people have jobs',
  } ],
}, {
  id: '12',
  title: 'What started the financial crisis in 2008?',
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: "Banks gave too many loans, expecting prices to rise. When prices fell, borrowers couldn't repay, causing bank troubles due to over-optimism.",
    icon: bank,
  },
  options: [ {
    id: '1',
    title: 'People spent too much on vacations',
  }, {
    id: '2',
    title: 'Banks gave out too many easy loans for houses',
    isCorrect: true,
  }, {
    id: '3',
    title: 'There was a global shortage of oil',
  }, {
    id: '4',
    title: 'Computers and technology failed worldwide',
  } ],
}, {
  id: '13',
  title: 'Would you be up for a financial challenge?',
  type: 'yesNo',
} ];

const teenQuestions: QuestionProps[] = [ {
  id: '1',
  title: 'How often do you and your child chat about money?',
  type: 'options',
  options: [ {
    id: '1',
    title: '<b>Often:</b> we chat about it everyday',
    isCorrect: true,
    icon: thumb,
  }, {
    id: '2',
    title: '<b>Sometimes:</b> it comes up sometimes',
    isCorrect: true,
    icon: sometimes,
  }, {
    id: '3',
    title: '<b>Rarely:</b> only during big financial decisions',
    isCorrect: true,
    icon: handshake,
  }, {
    id: '4',
    title: '<b>Not yet:</b> we haven’t started talking about it',
    isCorrect: true,
    icon: notEmoji,
  } ],
}, {
  id: '2',
  title: 'Is your child getting high quality financial education at school?',
  type: 'satisfaction',
}, {
  id: '3',
  title: 'What does your child do with money from gifts?',
  type: 'options',
  options: [ {
    id: '1',
    title: 'Spends it right away',
    isCorrect: true,
    icon: emojiMoney,
  }, {
    id: '2',
    title: 'Saves it',
    isCorrect: true,
    icon: bagOfMoney,
  }, {
    id: '3',
    title: 'Invests it',
    isCorrect: true,
    icon: chart,
  }, {
    id: '4',
    title: 'Not sure',
    isCorrect: true,
    icon: idk,
  } ],
}, {
  id: '4',
  title: 'Do you ever discuss investing or the stock market?',
  type: 'yesNo',
}, {
  id: '5',
  title: 'What’s a stock?',
  subtitle: "It's okay if you make mistakes",
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: 'A stock is a tiny piece of a company. Buying a stock makes you a mini-owner of a company, like owning a slice of a pizza.',
    icon: pizza,
  },
  options: [ {
    id: '1',
    title: 'A tiny piece of a company',
    isCorrect: true,
  }, {
    id: '2',
    title: 'A loan to the government',
  }, {
    id: '3',
    title: 'A coupon to buy items',
  }, {
    id: '4',
    title: 'A savings account',
  } ],
}, {
  id: '6',
  title: 'What is compound interest?',
  type: 'options',
  isKnowledge: true,
  didYouKnow: {
    description: "Saving 100€ monthly in a bank gets you 36,000€ in 30 years. Good, right? But if you invest that 100€? It could grow to 233,000€. That's the power of compound interest!",
    icon: money,
  },
  options: [ {
    id: '1',
    title: 'A special bank interest',
  }, {
    id: '2',
    title: 'Money making more money',
    isCorrect: true,
  }, {
    id: '3',
    title: 'Financial hobby',
  }, {
    id: '4',
    title: 'A one-time investing fee',
  } ],
}, {
  id: '7',
  title: 'How much do you trust your child with their financial choices?',
  type: 'satisfaction',
}, {
  id: '8',
  title: 'What interests would you like to guide your child in?',
  type: 'multipleOptions',
  options: [ {
    id: '1',
    title: 'Budgeting & money management',
  }, {
    id: '2',
    title: 'Basic Economic Principles',
  }, {
    id: '3',
    title: 'Investing Basics',
  }, {
    id: '4',
    title: 'Advanced Investing',
  }, {
    id: '5',
    title: 'Business & Entrepreneurship',
  }, {
    id: '6',
    title: 'Anti-scam practices',
  }, {
    id: '7',
    title: 'Other',
  } ],
}, {
  id: '9',
  title: 'How much learning do you want your child to do daily?',
  type: 'options',
  options: [ {
    id: '1',
    title: 'Easy',
    description: '5 min/day',
    isCorrect: true,
    icon: easy,
  }, {
    id: '2',
    title: 'Average',
    description: '10 min/day',
    isCorrect: true,
    icon: average,
  }, {
    id: '3',
    title: 'Serious',
    description: '15 min/day',
    isCorrect: true,
    icon: serious,
  }, {
    id: '4',
    title: 'Intensive',
    description: '20+ min/day',
    isCorrect: true,
    icon: strong,
  } ],
} ];

export const knowledgeQuestions = adultQuestions.filter(
  ( question ) => question.type === 'options' || question.type === 'imageOptions',
) as OptionsQuestionProps[];

export const satisfactionOptions = [ {
  id: '1',
  title: thumb,
  isImage: true,
  width: '18%',
  className: 'quizOptionThumb',
  isCorrect: true,
}, {
  id: '2',
  title: thumb,
  isImage: true,
  width: '18%',
  className: 'quizOptionThumb2',
  isCorrect: true,
}, {
  id: '3',
  title: noIdea,
  isImage: true,
  width: '18%',
  className: 'quizOptionThumb4',
  isCorrect: true,
}, {
  id: '4',
  title: thumb,
  isImage: true,
  width: '18%',
  className: 'quizOptionThumb3',
  isCorrect: true,
}, {
  id: '5',
  title: thumb,
  isImage: true,
  width: '18%',
  className: 'quizOptionThumb4',
  isCorrect: true,
} ];

export const yesNoOptions = [ {
  id: '1',
  title: thumb,
  isImage: true,
  width: 92,
  className: 'quizOptionThumb2',
  isCorrect: true,
}, {
  id: '2',
  title: thumb,
  isImage: true,
  width: 92,
  className: 'quizOptionThumb3',
  isCorrect: true,
} ];

export default {
  parent: teenQuestions,
  adult: adultQuestions,
};
